const ru = {
  copyLink: 'Копировать ссылку',
  copied: 'Скопировано!',
  share: 'Поделиться',
  description: 'Описание',
  usage: 'Примеры использования',
  usageHr: ' Использование в командах ',
  usageUiUx: 'Пример использования UI/UX',
  productText: 'Продукт Менеджмент',
  hrText: 'Управление персоналом',
  mentionedIn: 'Это искажение отвечает на следующие вопросы',
  productValue: 'Для продуктов',
  managementValue: 'Для менеджмента',
  answersLabel: 'Возможные ответы',
  relatedQuestionsLabel: 'Связанные вопросы',
  uxeducationButtonLabel: 'Использование UXCG в образовании',
  downloadButtonLabel: 'Скачать PDF',
  visualExample: 'Визуальный пример',
  offsecText: 'Наступательная кибербезопасность',
  offsecShortText: 'OffSec',
  usageOffsec: 'Пример использования в наступательной кибербезопасности',
  offsecComingSoon:
    'Сценарии для наступательной кибербезопасности — скоро. Мы готовим примеры для атакующей и защитной стороны для каждого искажения в UX Core.',
  nextLabel: 'Далее',
  prevLabel: 'Назад',
};

export default ru;
